module.exports = __webpack_public_path__ + "static/media/snooping.4627c20d.svg";